// @flow
import React, { Component } from 'react';
import AppNav from './../app-nav';

type LayoutProps = {
  children: any,
  className: string,
  viewType: string,
  isLeft: boolean
}
class OnboardView extends Component {
  props: LayoutProps;
  render() {
    if (document.body) {
      document.body.classList.add(this.props.viewType);
    }
    return (
      <div className={'app-container is-public'} >
        <AppNav />

        <div
          className={`
            container is-fluid page-container ${this.props.isLeft ? '' : 'is-centered'}
            ${this.props.className ? this.props.className : ''}
            `}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default OnboardView;



// WEBPACK FOOTER //
// ./src/components/layouts/PublicView.js